// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Login Google OAuth 2.0 (client NelDaari — l'écran de consentement affiche « NelDaari »).
// Flux authorization code : le code est échangé côté backend (client_secret jamais exposé).
const GOOGLE_AUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";
// Identifiant PUBLIC du client OAuth « NelDaari » (Google Cloud Console).
// Versionné dans le code car les fichiers .env sont ignorés par git : sans cela,
// un build mobile compilé depuis un clone git enverrait client_id=undefined
// (erreur Google « The OAuth client was not found / invalid_client »).
// L'env REACT_APP_GOOGLE_CLIENT_ID reste prioritaire si défini.
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
  || "715375720205-6n6901i6f82lu8tp4me17olg4dpbob1p.apps.googleusercontent.com";
export const GOOGLE_STATE_KEY = "neldaari_google_oauth_state";

function buildAuthorizeUrl(redirectUri, state) {
  const p = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    state,
    prompt: "select_account",
  });
  return `${GOOGLE_AUTH_URL}?${p.toString()}`;
}

/** Web : redirection classique, retour sur {origin}/auth/google?code=… */
export function startGoogleLogin() {
  const state = "web_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem(GOOGLE_STATE_KEY, state);
  const redirectUri = window.location.origin + "/auth/google";
  window.location.href = buildAuthorizeUrl(redirectUri, state);
}

/**
 * App native : navigateur INTÉGRÉ (SFSafariViewController / Custom Tab — Guideline 4).
 * Le retour passe par la page web /auth/google (domaine de production) qui relaie le
 * code vers neldaari://auth/google (capté par NativeAuthListener).
 */
export async function startNativeGoogleLogin() {
  const { Browser } = await import("@capacitor/browser");
  const state = "native_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  localStorage.setItem(GOOGLE_STATE_KEY, state);
  const redirectUri = process.env.REACT_APP_BACKEND_URL + "/auth/google";
  await Browser.open({ url: buildAuthorizeUrl(redirectUri, state) });
}
